import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ActionButton from './common/ActionButton'; // Import ActionButton

const JobOffersTable = ({ data = [], tenantId }) => { // Default data to empty array
  const { t } = useTranslation("DashboardPage"); // Or a dedicated namespace
  const navigate = useNavigate();

  const handleEdit = (jobId) => {
      if (!jobId || !tenantId) {
          console.error("Missing jobId or tenantId for edit navigation");
          return;
      }
    // Navigate to the specific job editing page
    navigate(`/jobpostings/${jobId}/tenants/${tenantId}`);
    // Or if the path is just /jobpostings/:jobId
    // navigate(`/jobpostings/${jobId}`);
  };

  // Helper to format date safely
  // eslint-disable-next-line no-unused-vars
  const formatDate = (dateString) => {
      if (!dateString) return t('n/a'); // Not available
      try {
          // Assuming dateString is ISO or compatible. Adjust if it's Firestore Timestamp object
          let date;
          if (typeof dateString === 'string') {
            date = new Date(dateString);
          } else if (dateString && typeof dateString.toDate === 'function') {
            date = dateString.toDate(); // Handle Firestore Timestamp
          } else {
            return new Date(
                dateString
              ).toLocaleDateString()
            
          }

          if (isNaN(date.getTime())) {
            console.log("Invalid date:", dateString);
              return t('invalidDate'); // Handle invalid date after parsing
          }
          // Use locale from i18n if needed: i18n.language
          return date.toLocaleDateString(navigator.language, { year: 'numeric', month: 'short', day: 'numeric' });
      } catch (error) {
          console.error("Error formatting date:", dateString, error);
          return t('invalidDate');
      }
  };


  return (
    <div className="overflow-x-auto p-4"> {/* Added padding */}
      {data.length === 0 ? (
           <p className="text-center text-slate-500 py-4">{t('noJobOffersFound')}</p> // Message when table is empty
      ) : (
          <table className="min-w-full bg-white border border-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">{t("tableId")}</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">{t("tableTitle")}</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">{t("tableRecruiter")}</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">{t("tableStatus")}</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">{t("tableDeadline")}</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">{t("tableLicense")}</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">{t("tableOptions")}</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {data.map((jobPosting) => (
                <tr key={jobPosting.uuid || jobPosting.JobID} className="hover:bg-gray-50"> {/* Use uuid or JobID */}
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-900 font-bold tracking-tight">{jobPosting.JobID || 'N/A'}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-900 font-bold tracking-tight">{jobPosting.Titre || 'N/A'}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-900 font-bold tracking-tight">{jobPosting.InformationsDeContact?.Email || 'N/A'}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-900 font-bold tracking-tight">{jobPosting.Statut || 'N/A'}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-900 font-bold tracking-tight"> {/**jobPosting.DateLimiteDeCandidature is a firastore timestamp need to display local*/}
                     
                    {new Date(
                    jobPosting.DateLimiteDeCandidature
                  ).toLocaleDateString()}
                    
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-900 font-bold tracking-tight capitalize">{jobPosting.type || 'N/A'}</td> {/* Added capitalize */}
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                    <ActionButton
                          className="text-indigo-600 hover:text-indigo-900"
                      onClick={() => handleEdit(jobPosting.uuid, jobPosting.tenantId)} // Pass job uuid and tenantId
                      color="lime"
                      size="sm" // Example: smaller button
                      disabled={!jobPosting.uuid || !jobPosting.tenantId} // Disable if IDs missing
                    >
                      {t("editButton")}
                    </ActionButton>
                    {/* Add other actions like View, Assign, Delete as needed */}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
       )}
    </div>
  );
};

JobOffersTable.propTypes = {
  // Ensure data prop matches the structure, use PropTypes.oneOfType for Firestore Timestamp or string
   data: PropTypes.arrayOf(
    PropTypes.shape({
      uuid: PropTypes.string, // Make uuid optional if JobID is always present as key fallback
      JobID: PropTypes.string.isRequired, // Assuming JobID is always there for display
      Titre: PropTypes.string,
      InformationsDeContact: PropTypes.shape({
        Email: PropTypes.string,
      }),
      Statut: PropTypes.string,
      DateLimiteDeCandidature: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.object // For Firestore Timestamp
      ]),
      type: PropTypes.string,
      tenantId: PropTypes.string.isRequired, // Ensure tenantId is passed if needed for actions
    })
  ).isRequired,
  tenantId: PropTypes.string.isRequired, // Make tenantId required if used in handleEdit
 // onOpenAssignModal: PropTypes.func, // Keep if assign action is added here
};

export default JobOffersTable;